(() => {
  'use strict';

  const ROOT = window.Shopify?.routes?.root || '/';
  const EVENT_NAME = 'shopify:cart:lines-update';
  const GIFT_PRODUCTS = { first: 7789491093582, second: 7933406347342, third: 8171398692942 };
  const ESSENTIAL_UPS_ID = 'cd9d48ef-8047-4f1f-b01b-f1136f2f5644';
  const ESSENTIAL_GIFT_TIERS = [
    {
      key: 'first',
      tierId: '6864e113-ba38-41d8-a899-08dddd03c7f8',
      minCents: 41000,
      productId: 7789491093582,
      handle: 'free-toy-gift',
      variantId: 43252403109966,
    },
    {
      key: 'second',
      tierId: '9d8814c3-139e-4e58-b597-342c04e51e31',
      minCents: 65000,
      productId: 7933406347342,
      handle: '2nd-random-toy',
      variantId: 43828729544782,
    },
    {
      key: 'third',
      tierId: '809831ae-179a-4811-be0c-5d2c76ab83d6',
      minCents: 110000,
      productId: 8171398692942,
      handle: '3rd-random-toy',
      variantId: 44694580101198,
    },
  ];

  let currentCart = null;
  let initPromise = null;
  let mutationQueue = Promise.resolve();
  let reconcileTimer = null;
  let nextOpId = 0;
  const pendingOps = new Map();
  const rewardRetryAfter = { first: 0, second: 0 };

  const money = (cents) => {
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        maximumFractionDigits: 0
      }).format(cents / 100);
    } catch (_) {
      return `₹${Math.round(cents / 100)}`;
    }
  };

  const configEl = () => document.getElementById('FM4Config');

  const config = () => {
    const el = configEl();

    return {
      enabled: false,

      t1: Number(
        el?.dataset.threshold1 || 45000
      ),

      t2: Number(
        el?.dataset.threshold2 || 75000
      ),

      shipping: Number(
        el?.dataset.shipping || 90000
      ),

      gift1: {
        productId: GIFT_PRODUCTS.first,

        handle:
          el?.dataset.gift1Handle ||
          'free-toy-gift',

        variantId: Number(
          el?.dataset.gift1Variant || 0
        ),

        available:
          el?.dataset.gift1Available !== 'false',
      },

      gift2: {
        productId: GIFT_PRODUCTS.second,

        handle:
          el?.dataset.gift2Handle ||
          '2nd-random-toy',

        variantId: Number(
          el?.dataset.gift2Variant || 0
        ),

        available:
          el?.dataset.gift2Available !== 'false',
      },
    };
  };


  /* =========================================================
     TOAST
     ========================================================= */

  const toast = (text) => {

    const el =
      document.getElementById('FM4Toast');

    if (!el) return;

    el.textContent = text;

    el.classList.add(
      'is-visible'
    );

    clearTimeout(
      el._timer
    );

    el._timer =
      setTimeout(() => {

        el.classList.remove(
          'is-visible'
        );

      }, 500);
  };


  /* =========================================================
     QUEUE
     ========================================================= */

  const enqueue = (task) => {

    const run =
      mutationQueue.then(
        task,
        task
      );

    mutationQueue =
      run.catch(() => {});

    return run;
  };


  /* =========================================================
     SHOPIFY CART SECTION IDS
     ========================================================= */

  const sectionIds = () => [

    ...new Set(

      [
        ...document.querySelectorAll(
          'cart-items-component[data-section-id]'
        )
      ]

      .map(
        (el) => el.dataset.sectionId
      )

      .filter(Boolean)

    ),

  ];


  const withSections = (payload) => {

    const ids =
      sectionIds();

    if (ids.length) {

      payload.sections =
        ids.join(',');

      payload.sections_url =
        window.location.pathname;

    }

    return payload;
  };


  /* =========================================================
     FETCH HELPER
     ========================================================= */

  async function jsonFetch(
    url,
    options = {}
  ) {

    const response =
      await fetch(
        url,
        {
          credentials:
            'same-origin',

          headers: {
            Accept:
              'application/json',

            ...(options.headers || {})
          },

          ...options,
        }
      );


    let data = null;

    try {

      data =
        await response.json();

    } catch (_) {}


    if (
      !response.ok ||
      data?.status
    ) {

      const message =
        data?.description ||
        data?.message ||
        `Request failed (${response.status})`;

      const error =
        new Error(message);

      error.response =
        data;

      throw error;
    }


    return data;
  }


  /* =========================================================
     GET CART
     ========================================================= */

  async function getCart() {

    return jsonFetch(
      `${ROOT}cart.js`
    );

  }


  /* =========================================================
     CART STATE HELPERS
     ========================================================= */

  const cloneCart = (cart) => ({

    ...(cart || {}),

    items:
      (cart?.items || []).map(
        (item) => ({

          ...item,

          properties:
            item.properties
              ? { ...item.properties }
              : item.properties,

        })
      ),

    item_count:
      Number(
        cart?.item_count || 0
      ),

  });


  const cartFromItems =
    (items = []) => ({

      items,

      item_count:
        items.reduce(
          (sum, item) =>
            sum +
            Number(
              item.quantity || 0
            ),
          0
        ),

    });


  /* =========================================================
     PAID SUBTOTAL
     Excludes reward products.
     ========================================================= */

  const paidSubtotal =
    (cart) =>
      (cart?.items || []).reduce(
        (sum, item) => {

          const productId =
            Number(
              item.product_id ||
              item.product?.id ||
              0
            );


          const isGift =

            productId ===
              GIFT_PRODUCTS.first ||

            productId ===
              GIFT_PRODUCTS.second ||

            productId ===
              GIFT_PRODUCTS.third ||

            Boolean(item.properties?.__essential_cart_drawer_reward_tier_id) ||

            Number(item.final_line_price ?? item.line_price ?? 0) === 0 ||

            item.properties
              ?._fm_reward_gift ===
                'true';


          return isGift

            ? sum

            : sum +
              Number(
                item.final_line_price ??
                item.line_price ??
                0
              );

        },
        0
      );


  /* =========================================================
     GIFT LINES
     ========================================================= */

  const giftLines =
    (cart, productId) =>

      (cart?.items || [])
      .filter(

        (item) =>

          Number(
            item.product_id ||
            item.product?.id ||
            0
          )

          ===

          Number(
            productId
          )

      );


  /* =========================================================
     VARIANT QTY
     ========================================================= */

  const paidVariantQty =
    (cart, variantId) =>

      (cart?.items || [])

      .filter(
        (item) =>

          Number(
            item.variant_id
          )

          ===

          Number(
            variantId
          )

          &&

          Number(
            item.product_id ||
            item.product?.id ||
            0
          )

          !==

          GIFT_PRODUCTS.first

          &&

          Number(
            item.product_id ||
            item.product?.id ||
            0
          )

          !==

          GIFT_PRODUCTS.second

          &&

          Number(
            item.product_id ||
            item.product?.id ||
            0
          )

          !==

          GIFT_PRODUCTS.third

          &&

          !item.properties?.__essential_cart_drawer_reward_tier_id

      )

      .reduce(

        (sum, item) =>
          sum +
          Number(
            item.quantity || 0
          ),

        0

      );


  const pendingForVariant = (variantId) => {
    const target = Number(variantId || 0);
    if (!target) return 0;
    let sum = 0;
    pendingOps.forEach((op) => {
      if (op.variantId === target) sum += op.delta;
    });
    return sum;
  };

  const getPendingItemDelta = () => {
    let sum = 0;
    pendingOps.forEach((op) => {
      sum += op.delta;
    });
    return sum;
  };

  const getPendingPaidDelta = () => {
    let sum = 0;
    pendingOps.forEach((op) => {
      sum += op.delta * op.price;
    });
    return sum;
  };


  function visualVariantQty(
    cart,
    variantId
  ) {

    return Math.max(

      0,

      paidVariantQty(
        cart,
        variantId
      )

      +

      pendingForVariant(
        variantId
      )

    );

  }


  /* =========================================================
     SYNC PRODUCT CARDS
     ========================================================= */

  function syncChoices(cart) {

    document
      .querySelectorAll(
        '.fm4-variant-choice'
      )
      .forEach(
        (choice) => {

          const variantId =
            Number(
              choice.dataset.fmVariantId ||
              0
            );


          if (!variantId)
            return;


          const qty =
            visualVariantQty(
              cart,
              variantId
            );


          const add =
            choice.querySelector(
              '.fm4-variant-add'
            );


          const controls =
            choice.querySelector(
              '.fm4-inline-qty'
            );


          const count =
            choice.querySelector(
              '[data-fm-qty]'
            );


          if (add)

            add.hidden =
              qty > 0;


          if (controls)

            controls.hidden =
              qty <= 0;


          if (count)

            count.textContent =
              String(qty);

        }
      );

    syncOfferBanner(cart);

  }

  function syncOfferBanner(cart) {
    const banner = document.getElementById('FM7OfferBanner');
    if (!banner) return;

    const paid = Math.max(0, paidSubtotal(cart) + getPendingPaidDelta());
    const t1 = 41000;
    const ship = 55000;
    const t2 = 65000;
    const t3 = 110000;

    let pct = 0;
    let msg = '';
    if (paid <= 0) {
      pct = 0;
      msg = '🎁 Add ₹410 to unlock your 1st FREE Mini Toy!';
    } else if (paid < t1) {
      pct = (paid / t1) * 25;
      msg = `🎁 Add ${money(t1 - paid)} more to unlock your 1st FREE Mini Toy!`;
    } else if (paid < ship) {
      pct = 25 + ((paid - t1) / (ship - t1)) * 25;
      msg = `✅ 1st Free Toy Unlocked! Add ${money(ship - paid)} for FREE Shipping 🚚`;
    } else if (paid < t2) {
      pct = 50 + ((paid - ship) / (t2 - ship)) * 25;
      msg = `✅ Free Toy + Free Ship Unlocked! Add ${money(t2 - paid)} for 2nd FREE Toy 🎁`;
    } else if (paid < t3) {
      pct = 75 + ((paid - t2) / (t3 - t2)) * 25;
      msg = `✅ 2 Free Toys + Free Ship Unlocked! Add ${money(t3 - paid)} for 3rd FREE Toy 🎁`;
    } else {
      pct = 100;
      msg = '🎉 ALL 4 REWARDS UNLOCKED! 3 Free Mini Toys + Free Shipping!';
    }

    const unlocked = (paid >= t1 ? 1 : 0) + (paid >= ship ? 1 : 0) + (paid >= t2 ? 1 : 0) + (paid >= t3 ? 1 : 0);

    const msgEl = banner.querySelector('[data-fm7-offer-msg]');
    if (msgEl) msgEl.textContent = msg;

    const countEl = banner.querySelector('[data-fm7-offer-count]');
    if (countEl) countEl.textContent = `${unlocked}/4 Unlocked`;

    const fillEl = banner.querySelector('[data-fm7-offer-fill]');
    if (fillEl) fillEl.style.width = `${Math.min(100, Math.max(0, pct)).toFixed(1)}%`;

    banner.querySelectorAll('[data-fm7-dot]').forEach((dotEl) => {
      const req = Number(dotEl.dataset.fm7Dot || 0);
      dotEl.classList.toggle('is-hit', paid >= req);
    });

    banner.querySelectorAll('[data-fm7-tier]').forEach((tierEl) => {
      const req = Number(tierEl.dataset.fm7Tier || 0);
      const prev = Number(tierEl.dataset.fm7Prev || 0);
      const isUnlocked = paid >= req;
      tierEl.classList.toggle('is-unlocked', isUnlocked);

      const tierFill = tierEl.querySelector('[data-fm7-tier-fill]');
      if (tierFill) {
        let segPct = 0;
        if (paid >= req) {
          segPct = 100;
        } else if (paid > prev && req > prev) {
          segPct = ((paid - prev) / (req - prev)) * 100;
        }
        tierFill.style.width = `${Math.min(100, Math.max(0, segPct)).toFixed(1)}%`;
      }

      const iconEl = tierEl.querySelector('[data-fm7-icon]');
      if (iconEl) {
        const defaultIcon = iconEl.dataset.fm7Icon || '🎁';
        iconEl.textContent = isUnlocked ? '✅' : defaultIcon;
      }
    });
  }


  /* =========================================================
     CART BADGE
     ========================================================= */

  function cartBadgeBaseCount() {

    return Number(
      currentCart?.item_count ||
      0
    );

  }


  function setCartBadge(count) {

    const safeCount =
      Math.max(
        0,
        Number(
          count || 0
        )
      );


    document
      .querySelectorAll(
        'cart-icon'
      )
      .forEach(
        (icon) => {

          const bubble =
            icon.querySelector(
              '.cart-bubble'
            );


          const countEl =
            icon.querySelector(
              '[data-testid="cart-bubble"]'
            );


          if (
            !bubble ||
            !countEl
          )
            return;


          if (
            safeCount > 0
          ) {

            bubble.classList.remove(
              'visually-hidden'
            );

            countEl.classList.remove(
              'hidden'
            );

            countEl.textContent =
              safeCount > 99
                ? '99+'
                : String(
                    safeCount
                  );

          } else {

            bubble.classList.add(
              'visually-hidden'
            );

            countEl.classList.add(
              'hidden'
            );

            countEl.textContent =
              '';

          }

        }
      );

  }


  function syncOptimisticBadge() {

    setCartBadge(

      cartBadgeBaseCount()

      +

      getPendingItemDelta()

    );

  }


  /* =========================================================
     CART ICON ANIMATION
     ========================================================= */

  function bumpCartIcon() {

    document
      .querySelectorAll(
        'cart-icon'
      )
      .forEach(
        (icon) => {

          icon.classList.remove(
            'fm-cart-bump'
          );


          void icon.offsetWidth;


          icon.classList.add(
            'fm-cart-bump'
          );


          setTimeout(
            () =>

              icon.classList.remove(
                'fm-cart-bump'
              ),

            420
          );

        }
      );

  }


  function visibleCartIcon() {

    return [

      ...document.querySelectorAll(
        'cart-icon'
      )

    ].find(
      (el) => {

        const r =
          el.getBoundingClientRect();


        return (

          r.width > 0

          &&

          r.height > 0

          &&

          r.bottom > 0

          &&

          r.top <
            window.innerHeight

        );

      }
    )

    ||

    document.querySelector(
      'cart-icon'
    );

  }


  /* =========================================================
     FLY TO CART
     ========================================================= */

  function flyToCart(trigger) {

    if (
      window.matchMedia
        ?.(
          '(prefers-reduced-motion: reduce)'
        )
        .matches
    ) {

      bumpCartIcon();

      return;
    }


    const card =
      trigger
        ?.closest(
          'article'
        );


    const image =
      card
        ?.querySelector(
          'img'
        );


    const target =
      visibleCartIcon();


    if (
      !image ||
      !target
    ) {

      bumpCartIcon();

      return;
    }


    const from =
      image
        .getBoundingClientRect();


    const to =
      target
        .getBoundingClientRect();


    if (
      !from.width ||
      !to.width
    ) {

      bumpCartIcon();

      return;
    }


    const clone =
      image.cloneNode(
        true
      );


    clone.className =
      'fm-cart-fly';


    clone.style.left =
      `${from.left}px`;


    clone.style.top =
      `${from.top}px`;


    clone.style.width =
      `${Math.min(
        from.width,
        90
      )}px`;


    clone.style.height =
      `${Math.min(
        from.height,
        90
      )}px`;


    document.body.appendChild(
      clone
    );


    const startX =
      from.left;


    const startY =
      from.top;


    const endX =
      to.left +
      to.width / 2 -
      Math.min(
        from.width,
        90
      ) / 2;


    const endY =
      to.top +
      to.height / 2 -
      Math.min(
        from.height,
        90
      ) / 2;


    requestAnimationFrame(
      () => {

        clone.style.transform =
          `translate3d(${endX - startX}px, ${endY - startY}px, 0) scale(.18)`;


        clone.style.opacity =
          '0.18';

      }
    );


    setTimeout(
      () => {

        clone.remove();

        bumpCartIcon();

      },
      390
    );

  }


  /* =========================================================
     PENDING STATE
     ========================================================= */

  function startPendingOp(variantId, itemDelta, price = 0) {
    const opId = ++nextOpId;
    pendingOps.set(opId, {
      variantId: Number(variantId || 0),
      delta: Number(itemDelta || 0),
      price: Number(price || 0),
    });
    syncChoices(currentCart || { items: [] });
    syncOptimisticBadge();
    return opId;
  }

  function finishPendingOp(opId) {
    if (opId && pendingOps.has(opId)) {
      pendingOps.delete(opId);
    }
    syncChoices(currentCart || { items: [] });
    syncOptimisticBadge();
  }


  /* =========================================================
     DISPATCH CART UPDATE
     ========================================================= */

  function dispatchCartUpdate(
    cart,
    sections = {},
    source = 'fm-fast-cart'
  ) {

    const event =
      new Event(
        EVENT_NAME,
        { bubbles: true }
      );


    event.action =
      'update';


    event.__fmFast =
      true;


    event.promise =
      Promise.resolve({

        cart: {

          totalQuantity:
            Number(
              cart?.item_count ||
              0
            )

        },


        detail: {

          sections:
            sections ||
            {},


          items:
            cart?.items ||
            [],


          itemCount:
            Number(
              cart?.item_count ||
              0
            ),


          source,


          didError:
            false,

        },

      });


    document.dispatchEvent(
      event
    );

  }


  /* =========================================================
     ENSURE CART
     ========================================================= */

  async function ensureCart() {

    if (currentCart)

      return currentCart;


    if (!initPromise) {

      initPromise =

        getCart()

        .then(
          (cart) => {

            currentCart =
              cart;


            syncChoices(
              cart
            );


            syncOptimisticBadge();


            return cart;

          }
        )

        .finally(
          () => {

            initPromise =
              null;

          }
        );

    }


    return initPromise;

  }


  /* =========================================================
     APPLY LOCAL ADD
     ========================================================= */

  function applyLocalAdd(
    cart,
    {
      variantId,
      productId,
      price = 0,
      quantity = 1,
      properties = null
    }
  ) {

    const next =
      cloneCart(
        cart
      );


    const vid =
      Number(
        variantId
      );


    const pid =
      Number(
        productId ||
        0
      );


    const qty =
      Number(
        quantity ||
        0
      );


    if (
      !vid ||
      qty <= 0
    )

      return next;


    const rewardFlag =
      properties
        ?._fm_reward_gift
      ===
      'true';


    const existing =
      next.items.find(
        (item) => {

          const itemReward =
            item.properties
              ?._fm_reward_gift
            ===
            'true';


          return (

            Number(
              item.variant_id
            )

            ===

            vid

            &&

            itemReward
            ===
            rewardFlag

          );

        }
      );


    if (existing) {

      existing.quantity =
        Number(
          existing.quantity ||
          0
        )

        +

        qty;


      existing.line_price =
        Number(
          existing.line_price ||
          0
        )

        +

        Number(
          price ||
          0
        )

        *

        qty;


      existing.final_line_price =
        Number(
          existing.final_line_price ||
          0
        )

        +

        Number(
          price ||
          0
        )

        *

        qty;

    }

    else {

      next.items.push({

        variant_id:
          vid,


        product_id:
          pid,


        quantity:
          qty,


        line_price:
          Number(
            price ||
            0
          )

          *

          qty,


        final_line_price:
          Number(
            price ||
            0
          )

          *

          qty,


        properties:
          properties ||
          {},

      });

    }


    next.item_count =
      Number(
        next.item_count ||
        0
      )

      +

      qty;


    return next;

  }


  /* =========================================================
     APPLY BUNDLE LOCALLY
     ========================================================= */

  function applyBundleLocally(
    cart,
    bundle,
    paidMeta
  ) {
    let next = cloneCart(cart);

    bundle.items.forEach((item, index) => {
      const isReward =
        Boolean(item.properties?.__essential_cart_drawer_reward_tier_id) ||
        Boolean(item.properties?._fm_reward_gift);

      if (index === 0 && !isReward) {
        next = applyLocalAdd(next, {
          variantId: item.id,
          productId: paidMeta.productId,
          price: paidMeta.price,
          quantity: item.quantity || 1,
          properties: item.properties || null,
        });
        return;
      }

      const tierId = item.properties?.__essential_cart_drawer_reward_tier_id;
      const tierObj = ESSENTIAL_GIFT_TIERS.find(
        (t) => t.tierId === tierId || t.variantId === Number(item.id)
      );
      const giftProductId = tierObj ? tierObj.productId : GIFT_PRODUCTS.first;

      next = applyLocalAdd(next, {
        variantId: item.id,
        productId: giftProductId,
        price: 0,
        quantity: item.quantity || 1,
        properties: item.properties || {},
      });
    });

    return next;
  }


  /* =========================================================
     RESOLVE GIFT VARIANT
     ========================================================= */

  async function resolveGiftVariant(
    gift,
    tierName
  ) {

    if (
      gift.variantId &&
      gift.available
    )

      return gift.variantId;


    if (
      Date.now()
      <
      rewardRetryAfter[
        tierName
      ]
    )

      return 0;


    const cacheKey =
      `fm-gift-${gift.productId}`;


    try {

      const cached =
        JSON.parse(
          sessionStorage.getItem(
            cacheKey
          )
          ||
          '{}'
        );


      if (
        Number(
          cached.variantId
        )

        &&

        cached.available
          !== false
      )

        return Number(
          cached.variantId
        );

    }

    catch (_) {}


    try {

      const product =
        await jsonFetch(
          `${ROOT}products/${gift.handle}.js`
        );


      if (
        Number(
          product?.id
        )

        !==

        Number(
          gift.productId
        )
      )

        throw new Error(
          'Reward product mismatch'
        );


      const variant =
        (product.variants || [])
        .find(
          (v) => v.available
        );


      if (!variant) {

        rewardRetryAfter[
          tierName
        ] =
          Date.now()
          +
          60000;


        return 0;

      }


      sessionStorage.setItem(

        cacheKey,

        JSON.stringify({

          variantId:
            variant.id,


          available:
            true,

        })

      );


      return Number(
        variant.id
      );

    }

    catch (error) {

      rewardRetryAfter[
        tierName
      ] =
        Date.now()
        +
        60000;


      console.warn(
        `[FM rewards] ${tierName} reward unavailable`,
        error
      );


      return 0;

    }

  }


  /* =========================================================
     GIFT UPDATE MAP
     ========================================================= */

  function giftUpdateMap(cart, predictedPaidCents) {
    const updates = {};
    const paid = typeof predictedPaidCents === 'number' ? predictedPaidCents : paidSubtotal(cart);

    for (const tier of ESSENTIAL_GIFT_TIERS) {
      const desired = paid >= tier.minCents;
      const lines = (cart?.items || []).filter((item) => {
        const pid = Number(item.product_id || item.product?.id || 0);
        const tid = item.properties?.__essential_cart_drawer_reward_tier_id;
        return tid === tier.tierId || pid === tier.productId;
      });

      if (!lines.length) continue;

      if (!desired) {
        lines.forEach((line) => {
          updates[line.key || String(line.variant_id)] = 0;
        });
        continue;
      }

      let kept = false;
      lines.forEach((line) => {
        const key = line.key || String(line.variant_id);
        const hasEssentialProp = line.properties?.__essential_cart_drawer_reward_tier_id === tier.tierId;
        if (!kept && hasEssentialProp) {
          if (Number(line.quantity) !== 1) updates[key] = 1;
          kept = true;
        } else {
          updates[key] = 0;
        }
      });
    }

    return updates;
  }


  /* =========================================================
     SHOPIFY ADD ITEMS
     ========================================================= */

  async function addItems(
    items
  ) {

    return jsonFetch(

      `${ROOT}cart/add.js`,

      {

        method:
          'POST',


        headers: {

          'Content-Type':
            'application/json'

        },


        body:
          JSON.stringify(

            withSections({

              items

            })

          ),

      }

    );

  }


  /* =========================================================
     SHOPIFY UPDATE CART
     ========================================================= */

  async function updateCart(
    updates
  ) {

    return jsonFetch(

      `${ROOT}cart/update.js`,

      {

        method:
          'POST',


        headers: {

          'Content-Type':
            'application/json'

        },


        body:
          JSON.stringify(

            withSections({

              updates

            })

          ),

      }

    );

  }


  /* =========================================================
     ADD MISSING REWARDS
     ========================================================= */

  async function addMissingRewards(
    cart,
    paid,
    extraItems = []
  ) {
    const resultItems = [...extraItems];

    for (const tier of ESSENTIAL_GIFT_TIERS) {
      if (paid < tier.minCents) continue;

      const alreadyInCart = (cart?.items || []).some((item) => {
        const tid = item.properties?.__essential_cart_drawer_reward_tier_id;
        const pid = Number(item.product_id || item.product?.id || 0);
        return tid === tier.tierId || (pid === tier.productId && Boolean(tid));
      });

      if (!alreadyInCart && tier.variantId) {
        resultItems.push({
          id: tier.variantId,
          quantity: 1,
          properties: {
            __essential_cart_drawer_reward_tier_id: tier.tierId,
            __essential_cart_drawer_upsell_id: ESSENTIAL_UPS_ID,
          },
        });
      }
    }

    return { items: resultItems };
  }


  /* =========================================================
     RECONCILE REWARDS
     ========================================================= */

  async function reconcileRewards(
    cart,
    {
      dispatch = true
    } = {}
  ) {
    if (!cart || !Array.isArray(cart.items)) return cart;

    // Remove any gift line that lacks Essential Cart's __essential_cart_drawer_reward_tier_id
    // OR any gift line that has final_line_price > 0 (meaning the cart is below threshold so it isn't ₹0 Free).
    const updates = {};
    for (const item of cart.items) {
      const pid = Number(item.product_id || item.product?.id || 0);
      const isGiftProduct =
        pid === GIFT_PRODUCTS.first ||
        pid === GIFT_PRODUCTS.second ||
        pid === GIFT_PRODUCTS.third;
      const isLegacyFmGift = item.properties?._fm_reward_gift === 'true';
      const isEssentialGift = Boolean(item.properties?.__essential_cart_drawer_reward_tier_id);
      const linePrice = Number(item.final_line_price ?? item.line_price ?? 0);

      if (isLegacyFmGift || (isGiftProduct && (!isEssentialGift || linePrice > 0))) {
        const key = item.key || String(item.variant_id);
        updates[key] = 0;
      }
    }

    if (Object.keys(updates).length > 0) {
      try {
        const updated = await updateCart(updates);
        currentCart = updated;
        syncChoices(updated);
        syncOptimisticBadge();
        return updated;
      } catch (err) {
        console.warn('[FM cart] Failed to clean gift lines', err);
      }
    }

    return cart;
  }


  /* =========================================================
     BACKGROUND CART RECONCILIATION
     ========================================================= */

  function scheduleServerReconcile(
    delay = 800
  ) {

    clearTimeout(
      reconcileTimer
    );


    reconcileTimer =
      setTimeout(
        () => {

          enqueue(
            async () => {

              const fresh =
                await getCart();


              currentCart =
                fresh;


              syncChoices(
                fresh
              );


              syncOptimisticBadge();


              const reconciled =
                await reconcileRewards(

                  fresh,

                  {
                    dispatch:
                      true
                  }

                );


              currentCart =
                reconciled;


              syncChoices(
                reconciled
              );


              syncOptimisticBadge();

            }
          )

          .catch(
            (error) =>

              console.warn(

                '[FM cart] Background reconciliation failed',

                error

              )
          );

        },

        delay
      );

  }


  /* =========================================================
     FAST PRODUCT CARD ADD
     ========================================================= */

  async function addPaidVariant({
    variantId,
    productId,
    price,
    product,
    label,
    opId
  }) {

    let cart =
      await ensureCart();


    const predictedPaid =

      paidSubtotal(
        cart
      )

      +

      Number(
        price ||
        0
      );


    const paidItem = {

      id:
        Number(
          variantId
        ),

      quantity:
        1

    };


    let bundle =
      await addMissingRewards(

        cart,

        predictedPaid,

        [
          paidItem
        ]

      );


    let response;


    try {

      response =
        await addItems(
          bundle.items
        );

    }

    catch (error) {

      if (
        bundle.items.length
        >
        1
      ) {

        console.warn(

          '[FM rewards] Reward batch failed; adding paid item alone',

          error

        );


        bundle = {

          items: [
            paidItem
          ]

        };


        response =
          await addItems(
            bundle.items
          );

      }

      else {

        throw error;

      }

    }


    currentCart =
      applyBundleLocally(

        cart,

        bundle,

        {

          productId:
            Number(
              productId ||
              0
            ),


          price:
            Number(
              price ||
              0
            ),

        }

      );


    if (opId) pendingOps.delete(opId);

    syncChoices(
      currentCart
    );

    syncOptimisticBadge();




    dispatchCartUpdate(

      currentCart,

      response.sections,

      'fm-direct-add'

    );


    scheduleServerReconcile();


    return currentCart;

  }


  /* =========================================================
     DECREMENT CARD VARIANT
     ========================================================= */

  async function decrementVariant(
    choice,
    opId
  ) {

    let cart =
      await ensureCart();


    const variantId =
      Number(
        choice.dataset.fmVariantId ||
        0
      );


    const unitPrice =
      Number(
        choice.dataset.fmPrice ||
        0
      );


    const qty =
      paidVariantQty(
        cart,
        variantId
      );


    if (
      !variantId ||
      qty <= 0
    )

      return cart;


    const line =
      (cart.items || [])
      .find(
        (item) =>

          Number(
            item.variant_id
          )

          ===

          variantId

          &&

          Number(
            item.product_id ||
            item.product?.id ||
            0
          )

          !==

          GIFT_PRODUCTS.first

          &&

          Number(
            item.product_id ||
            item.product?.id ||
            0
          )

          !==

          GIFT_PRODUCTS.second

          &&

          Number(
            item.product_id ||
            item.product?.id ||
            0
          )

          !==

          GIFT_PRODUCTS.third

          &&

          !item.properties?.__essential_cart_drawer_reward_tier_id

      );


    if (!line)

      return cart;


    const predictedPaid =
      Math.max(

        0,

        paidSubtotal(
          cart
        )

        -

        unitPrice

      );


    const cfg =
      config();


    const updates = {

      [
        line.key ||
        String(
          variantId
        )
      ]:

        Math.max(
          0,
          qty - 1
        )

    };


    Object.assign(
      updates,
      giftUpdateMap(cart, predictedPaid)
    );


    const updated =
      await updateCart(
        updates
      );


    currentCart =
      updated;

    if (opId) pendingOps.delete(opId);

    syncChoices(
      updated
    );

    syncOptimisticBadge();




    dispatchCartUpdate(

      updated,

      updated.sections,

      'fm-direct-quantity'

    );


    scheduleServerReconcile();


    return updated;

  }


  /* =========================================================
     OPTIMISTIC ADD / DECREMENT WITH IDEMPOTENT OP TRACKING
     ========================================================= */

  function optimisticAdd(choice, trigger) {
    const variantId = Number(choice?.dataset.fmVariantId || 0);
    if (!variantId) return 0;

    const price = Number(choice?.dataset.fmPrice || 0);
    const opId = startPendingOp(variantId, +1, price);

    flyToCart(trigger);

    const product = choice.dataset.fmProduct || 'Product';
    const label = choice.dataset.fmLabel || '';
    toast(`✓ ${product}${label ? ` · ${label}` : ''} added`);
    return opId;
  }

  function optimisticDecrement(choice) {
    const variantId = Number(choice?.dataset.fmVariantId || 0);
    if (!variantId || visualVariantQty(currentCart || { items: [] }, variantId) <= 0) {
      return 0;
    }
    const price = Number(choice?.dataset.fmPrice || 0);
    return startPendingOp(variantId, -1, price);
  }

  function optimisticDirect(trigger) {
    const variantId = Number(trigger.dataset.variantId || 0);
    const price = Number(trigger.dataset.fmPrice || trigger.dataset.price || 0);
    const opId = startPendingOp(variantId, +1, price);

    flyToCart(trigger);

    const original = trigger.textContent;
    trigger.textContent = '✓ ADDED';
    trigger.classList.add('fm-added-now');

    setTimeout(() => {
      trigger.textContent = original;
      trigger.classList.remove('fm-added-now');
    }, 500);

    toast(`✓ ${trigger.dataset.productTitle || 'Product'} added`);
    return opId;
  }

  /* =========================================================
     CUSTOM PRODUCT CARD BUTTON CLICKS
     ========================================================= */

  document.addEventListener(
    'click',
    (event) => {
      const openCartLink = event.target.closest('[data-fm7-open-cart]');
      if (openCartLink) {
        event.preventDefault();
        if (window.essentialCartApi?.openCart) {
          window.essentialCartApi.openCart();
          return;
        }
        const cartTrigger = document.querySelector('cart-icon button, cart-icon a, [data-testid="cart-drawer-trigger"], cart-icon');
        if (cartTrigger) {
          cartTrigger.click();
          return;
        }
      }

      /* ADD BUTTON */
      const add = event.target.closest('.fm4-variant-add');
      if (add) {
        event.preventDefault();
        const choice = add.closest('.fm4-variant-choice');
        if (!choice || add.disabled) return;

        const opId = optimisticAdd(choice, add);

        enqueue(() =>
          addPaidVariant({
            variantId: Number(choice.dataset.fmVariantId),
            productId: Number(choice.dataset.fmProductId || 0),
            price: Number(choice.dataset.fmPrice || 0),
            product: choice.dataset.fmProduct || 'Product',
            label: choice.dataset.fmLabel || '',
            opId,
          })
        ).catch((error) => {
          console.warn('[FM cart] Add failed', error);
          finishPendingOp(opId);
          toast('Could not add — tap to retry');
        });
        return;
      }

      /* SINGLE ADD TO CART */
      const direct = event.target.closest('[data-fm4-add]');
      if (direct) {
        event.preventDefault();
        if (direct.disabled) return;

        const opId = optimisticDirect(direct);

        enqueue(() =>
          addPaidVariant({
            variantId: Number(direct.dataset.variantId),
            productId: Number(direct.dataset.productId || 0),
            price: Number(direct.dataset.fmPrice || direct.dataset.price || 0),
            product: direct.dataset.productTitle || 'Product',
            label: direct.dataset.variantTitle || '',
            opId,
          })
        ).catch((error) => {
          console.warn('[FM cart] Direct add failed', error);
          finishPendingOp(opId);
          toast('Could not add — tap to retry');
        });
        return;
      }

      /* + INCREMENT */
      const inc = event.target.closest('[data-fm-inc]');
      if (inc) {
        event.preventDefault();
        const choice = inc.closest('.fm4-variant-choice');
        if (!choice) return;

        const opId = optimisticAdd(choice, inc);

        enqueue(() =>
          addPaidVariant({
            variantId: Number(choice.dataset.fmVariantId),
            productId: Number(choice.dataset.fmProductId || 0),
            price: Number(choice.dataset.fmPrice || 0),
            product: choice.dataset.fmProduct || 'Product',
            label: choice.dataset.fmLabel || '',
            opId,
          })
        ).catch((error) => {
          console.warn('[FM cart] Increment failed', error);
          finishPendingOp(opId);
          toast('Could not update cart');
        });
        return;
      }

      /* - DECREMENT */
      const dec = event.target.closest('[data-fm-dec]');
      if (dec) {
        event.preventDefault();
        const choice = dec.closest('.fm4-variant-choice');
        if (!choice) return;
        const opId = optimisticDecrement(choice);
        if (!opId) return;

        enqueue(() => decrementVariant(choice, opId)).catch((error) => {
          console.warn('[FM cart] Decrement failed', error);
          finishPendingOp(opId);
          toast('Could not update cart');
        });
      }
    }
  );


  /* =========================================================
     PRODUCT PAGE / HORIZON ADD TO CART FIX
     ========================================================= */

  async function refreshCartSectionsForNativeAdd(
    cart,
    sections,
    source = 'fm-native-product-sync'
  ) {

    let resolvedSections =

      sections

      &&

      typeof sections ===
        'object'

        ? sections

        : {};


    const ids =
      sectionIds();


    /*
     * Normally Horizon returns the updated cart drawer
     * HTML with the product add request.
     *
     * If not, fetch only the cart sections.
     */

    if (

      !Object.keys(
        resolvedSections
      ).length

      &&

      ids.length

    ) {

      try {

        const url =
          new URL(
            window.location.href
          );


        url.search =
          '';


        url.hash =
          '';


        url.searchParams.set(

          'sections',

          ids.join(',')

        );


        resolvedSections =
          await jsonFetch(
            url.toString()
          );

      }

      catch (error) {

        console.warn(

          '[FM cart] Could not refresh cart sections after product-page add',

          error

        );

      }

    }


    dispatchCartUpdate(

      cart,

      resolvedSections,

      source

    );

  }


  /* =========================================================
     LISTEN TO HORIZON CART EVENTS
     ========================================================= */

  document.addEventListener(

    EVENT_NAME,

    (event) => {


      /*
       * Ignore our own re-dispatched event.
       */

      if (
        event.__fmFast
      )

        return;


      /*
       * Detect a normal Horizon product-page
       * Add to cart action.
       */

      const isNativeProductAdd =

        event.action === 'add'

        &&

        event.context === 'product'

        &&

        event.target
          instanceof Element

        &&

        Boolean(

          event.target.closest(
            'product-form-component'
          )

        );


      /*
       * Quantity selected on product page.
       *
       * Example:
       *
       * quantity = 3
       *
       * badge 9 -> 12 immediately.
       */

      const optimisticDelta =

        isNativeProductAdd

        ?

        (
          Array.isArray(
            event.lines
          )

          ?

          event.lines

          :

          []
        )

        .reduce(

          (sum, line) =>

            sum

            +

            Math.max(

              0,

              Number(
                line?.quantity ||
                0
              )

            ),

          0

        )

        :

        0;


      /* =====================================================
         IMMEDIATE PRODUCT PAGE FEEDBACK
         ===================================================== */

      if (
        optimisticDelta > 0
      ) {

        


        syncOptimisticBadge();


        bumpCartIcon();


        toast(

          optimisticDelta > 1

            ?

            `✓ ${optimisticDelta} items added`

            :

            '✓ Added to cart'

        );

      }


      /* =====================================================
         WHEN SHOPIFY CONFIRMS THE REQUEST
         ===================================================== */

      const settle =
        async ({
          cart,
          detail
        } = {}) => {


          /*
           * Remove temporary optimistic count.
           */

          if (
            optimisticDelta > 0
          ) {

            

          }


          /*
           * Shopify rejected add.
           */

          if (
            detail?.didError
          ) {

            syncChoices(

              currentCart ||
              { items: [] }

            );


            syncOptimisticBadge();


            toast(
              'Could not add — tap to retry'
            );


            return;
          }


          /*
           * Horizon provided complete cart lines.
           */

          const items =

            Array.isArray(
              detail?.items
            )

            ?

            detail.items

            :

            null;


          if (items) {

            currentCart =
              cartFromItems(
                items
              );


            /*
             * Horizon's totalQuantity is authoritative.
             */

            if (
              cart?.totalQuantity !==
              undefined
            ) {

              currentCart.item_count =
                Number(
                  cart.totalQuantity ||
                  0
                );

            }


            pendingOps.clear();


            syncChoices(
              currentCart
            );


            syncOptimisticBadge();


            /*
             * IMPORTANT:
             *
             * Product-page add should update
             * the actual cart drawer HTML too.
             */

            if (
              isNativeProductAdd
            ) {

              await refreshCartSectionsForNativeAdd(

                currentCart,

                detail?.sections,

                'fm-product-page-confirm'

              );


              scheduleServerReconcile(
                700
              );

            }

            else {

              scheduleServerReconcile(
                300
              );

            }


            return;
          }


          /* =================================================
             Horizon gave total quantity but not line items.
             Fetch confirmed cart state.
             ================================================= */

          if (
            cart?.totalQuantity !==
            undefined
          ) {

            try {

              const fresh =
                await getCart();


              currentCart =
                fresh;


              pendingOps.clear();


              syncChoices(
                fresh
              );


              syncOptimisticBadge();


              if (
                isNativeProductAdd
              ) {

                await refreshCartSectionsForNativeAdd(

                  fresh,

                  detail?.sections,

                  'fm-product-page-confirm'

                );


                scheduleServerReconcile(
                  700
                );

              }

              else {

                scheduleServerReconcile(
                  250
                );

              }

            }

            catch (error) {

              console.warn(

                '[FM cart] Native cart confirmation failed',

                error

              );


              syncOptimisticBadge();

            }

          }

          else {

            /*
             * Unknown third-party event.
             * Quietly reconcile.
             */

            syncOptimisticBadge();


            scheduleServerReconcile(
              250
            );

          }

        };


      /* =====================================================
         WAIT FOR HORIZON PROMISE
         ===================================================== */

      if (
        event.promise?.then
      ) {

        event.promise

        .then(
          settle
        )

        .catch(
          (error) => {


            if (
              optimisticDelta > 0
            ) {

              


              syncOptimisticBadge();


              toast(
                'Could not add — tap to retry'
              );

            }


            if (
              error?.name !==
              'AbortError'
            ) {

              console.warn(

                '[FM cart] Native cart event failed',

                error

              );

            }

          }
        );

      }

    }

  );


  /* =========================================================
     ESSENTIAL CART DRAWER TWO-WAY SYNC & STICKY HEADER OFFSET
     ========================================================= */

  function syncStickyHeaderOffset() {
    const header = document.querySelector('#header-component') || document.querySelector('.header-section');
    if (header && header.offsetHeight > 20) {
      document.body.style.setProperty('--header-height', `${header.offsetHeight}px`);
    }
  }

  window.addEventListener('resize', syncStickyHeaderOffset, { passive: true });
  window.addEventListener('scroll', syncStickyHeaderOffset, { passive: true, once: true });

  function applyEssentialCartState(cartData) {
    if (cartData && Array.isArray(cartData.items)) {
      currentCart = cloneCart(cartData);
      if (pendingOps.size === 0) {
        syncChoices(currentCart);
        syncOptimisticBadge();
      }
    } else if (pendingOps.size === 0) {
      scheduleServerReconcile(120);
    }
  }

  document.addEventListener('essential-cart:update', (event) => {
    applyEssentialCartState(event?.detail);
  });

  if (window.essentialCartApi?.onCartUpdate) {
    try { window.essentialCartApi.onCartUpdate((cartData) => applyEssentialCartState(cartData)); } catch (_) {}
  }

  document.addEventListener('click', (event) => {
    const portal = document.getElementById('essential-cart-drawer-portal') || document.querySelector('essential-cart-app-embed');
    if (portal && (portal.contains(event.target) || event.composedPath?.().includes(portal))) {
      scheduleServerReconcile(350);
      setTimeout(() => scheduleServerReconcile(100), 900);
    }
  }, true);

  document.addEventListener('essential-cart:close', () => {
    const data = window.essentialCartApi?.getCartData?.();
    if (data && Array.isArray(data.items)) {
      applyEssentialCartState(data);
    } else {
      scheduleServerReconcile(100);
    }
  });

  document.addEventListener('cart:updated', (event) => {
    const data = event?.detail?.cart || window.essentialCartApi?.getCartData?.();
    if (data && Array.isArray(data.items)) {
      applyEssentialCartState(data);
    } else if (event?.detail?.source === 'essential-cart') {
      scheduleServerReconcile(120);
    }
  });

  /* =========================================================
     INITIALISE
     ========================================================= */

  function prewarmGiftProducts() {
    const run = () => {
      ESSENTIAL_GIFT_TIERS.forEach((t) => {
        fetch(`${ROOT}products/${t.handle}.js`, { credentials: 'same-origin' }).catch(() => {});
      });
    };
    if (window.requestIdleCallback) {
      window.requestIdleCallback(run, { timeout: 2000 });
    } else {
      setTimeout(run, 600);
    }
  }

  async function initialise() {
    syncStickyHeaderOffset();
    prewarmGiftProducts();

    try {

      currentCart =
        await getCart();


      pendingOps.clear();


      pendingOps.clear();


      syncChoices(
        currentCart
      );


      syncOptimisticBadge();


      await enqueue(
        () =>
          reconcileRewards(

            currentCart,

            {
              dispatch:
                true
            }

          )
      );

    }

    catch (error) {

      console.warn(

        '[FM cart] Initialisation failed',

        error

      );

    }

  }


  /* =========================================================
     START
     ========================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(

      'DOMContentLoaded',

      initialise,

      {
        once:
          true
      }

    );

  }

  else {

    initialise();

  }


  /* =========================================================
     BROWSER BACK/FORWARD CACHE
     ========================================================= */

  window.addEventListener(

    'pageshow',

    (event) => {


      if (
        !event.persisted
      )

        return;


      currentCart =
        null;


      pendingOps.clear();


      pendingOps.clear();


      enqueue(
        async () => {

          currentCart =
            await getCart();


          syncChoices(
            currentCart
          );


          syncOptimisticBadge();


          return reconcileRewards(

            currentCart,

            {
              dispatch:
                true
            }

          );

        }
      )

      .catch(
        (error) =>

          console.warn(

            '[FM cart] bfcache refresh failed',

            error

          )
      );

    }

  );

})();